import { useMemo } from 'react';

import { useAppSelector } from '@/store/hooks';
import { selectProjectSettings } from '@/store/slices/project/selectors';
import getThemeFontFamilyClass from './fonts/get-theme-font-family-class';
import useGetWorkingProjectThemePack from './use-get-working-project-theme-pack';

const useGetFontFamilyClass = () => {
  const activeThemePack = useGetWorkingProjectThemePack();
  const projectSettings = useAppSelector(selectProjectSettings);
  const hasCustomFont = activeThemePack?.font_pack && projectSettings?.design.use_project_theme;

  return useMemo(() => {
    if (!hasCustomFont) return '';
    return getThemeFontFamilyClass(activeThemePack?.font_pack?.font_pack || 0);
  }, [activeThemePack?.font_pack?.font_pack, hasCustomFont]);
};

export default useGetFontFamilyClass;
